import user from "@/store/modules/authorization_store";

const getKey = () => {
    return (user.state && user.state.keyUser) || localStorage.getItem('keyUser') || 'default_user';
};

const loadFromStorage = (suffix) => {
    try {
        const key = getKey();
        const savedData = localStorage.getItem(key + suffix);
        if (savedData && savedData !== 'null' && savedData !== 'undefined') {
            return JSON.parse(savedData);
        }
    } catch (e) {}
    return null;
};

const state = {
    searchAccidentParams: loadFromStorage('_accident_searchParams'),
    infoOffer: loadFromStorage('_accident_infoOrder'),
    fullOrderInfo: loadFromStorage('_accident_fullInfoOrder'),
    infoUser: null,
    contractId: null,
};

const getters = {
    GET_SEARCH_ACCIDENT_PARAMS: state => state.searchAccidentParams,
    GET_ACCIDENT_INFO_OFFER: state => state.infoOffer,
    GET_ACCIDENT_INFO_USER: state => state.infoUser,
    GET_ACCIDENT_FULL_ORDER: state => state.fullOrderInfo,
    GET_ACCIDENT_CONTRACT_ID: state => state.contractId,
};

const mutations = {
    SET_SEARCH_ACCIDENT_PARAMS: (state, data) => {
        state.searchAccidentParams = data;
        localStorage.setItem(getKey() + '_accident_searchParams', JSON.stringify(data));
    },
    SET_ACCIDENT_INFO_OFFER: (state, data) => {
        state.infoOffer = data;
        localStorage.setItem(getKey() + '_accident_infoOrder', JSON.stringify(data));
    },
    SET_ACCIDENT_FULL_ORDER: (state, orderData) => {
        state.fullOrderInfo = orderData;
        localStorage.setItem(getKey() + '_accident_fullInfoOrder', JSON.stringify(state.fullOrderInfo));
    },
    SET_ACCIDENT_CONTRACT_ID: (state, data) => {
        state.contractId = data;
    },
    CLEAR_ACCIDENT_FULL_ORDER: (state) => {
        state.fullOrderInfo = null;
        localStorage.removeItem(getKey() + '_accident_infoOrder');
        localStorage.removeItem(getKey() + '_accident_fullInfoOrder');
    },
    CLEAR_ACCIDENT_CONTRACT_ID: (state) => {
        state.contractId = null;
    },
    CLEAR_SEARCH_ACCIDENT_PARAMS: (state) => {
        state.searchAccidentParams = null;
        localStorage.removeItem(getKey() + '_accident_searchParams');
    },
    CLEAR_ACCIDENT_INFO_OFFER: (state) => {
        state.infoOffer = null;
        localStorage.removeItem(getKey() + '_accident_infoOrder');
    },
    CLEAR_ACCIDENT_INFO_USER: (state) => {
        state.infoUser = null;
    },
    SET_ACCIDENT_INFO_USER: (state, data) => {
        state.infoUser = data;
    },
    INIT_SEARCH_ACCIDENT_PARAMS: (state) => {
        state.searchAccidentParams = loadFromStorage('_accident_searchParams');
    },
    INIT_ACCIDENT_FULL_INFO_ORDER: (state) => {
        state.fullOrderInfo = loadFromStorage('_accident_fullInfoOrder');
    },
    INIT_ACCIDENT_INFO_ORDER: (state) => {
        state.infoOffer = loadFromStorage('_accident_infoOrder');
    },
};

const actions = {
    initSearchAccidentParams({ commit }) {
        commit('INIT_SEARCH_ACCIDENT_PARAMS');
    },
    initAccidentFullInfoOrder({ commit }) {
        commit('INIT_ACCIDENT_FULL_INFO_ORDER');
    },
    initAccidentInfoOrder({ commit }) {
        commit('INIT_ACCIDENT_INFO_ORDER');
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
};
